import React, { useEffect, useRef, useState } from 'react';
import './WhyChoose.css';

const benefits = [
  {
    title: 'Pay‑as‑you‑want',
    description: 'No paywall. You decide if and how much you want to contribute to improve our services.'
  },
  {
    title: 'Science‑backed',
    description: 'Grounded in peer‑reviewed research on micro‑breaks, focus, posture, and wellbeing.'
  },
  {
    title: 'Laptop‑first web app',
    description: 'Made for your laptop browser, so guidance appears right where you work and study.'
  },
  {
    title: 'Future‑ready mobile app',
    description: 'Planned mobile app so you can follow the same guidance on all your devices.'
  },
  {
    title: 'Community‑driven',
    description: 'Join students and professionals who are actively building healthier work habits.'
  },
  {
    title: 'Privacy‑first',
    description: 'Your data stays under your control, with no selling or unnecessary tracking.'
  }
];

function WhyChoose() {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <section className="why-choose">
      <div className="why-choose-container">
        {/* Section Header */}
        <div className="why-choose-header">
          <h2 className="why-choose-title title-1">Why join within?</h2>
        </div>

        {/* Benefits Grid */}
        <div 
          ref={ref}
          className={`why-choose-grid ${isVisible ? 'why-choose-visible' : ''}`}
        >
          {benefits.map((benefit, index) => (
            <div 
              key={benefit.title} 
              className="why-choose-item"
              style={{ transitionDelay: `${index * 50}ms` }}
            >
              {/* Check Icon */}
              <div className="why-choose-icon">
                <svg 
                  width="20" 
                  height="20" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2"
                >
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
              </div>
              
              {/* Content */}
              <div className="why-choose-content">
                <h3 className="why-choose-item-title title-3">{benefit.title}</h3>
                <p className="why-choose-item-description body-text-secondary">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyChoose;

